module.exports = __webpack_public_path__ + "static/media/cassette-tape.d7282e40.svg";